import { render } from "./ShowCatastro.vue?vue&type=template&id=19cacc37&scoped=true"
import script from "./ShowCatastro.vue?vue&type=script&lang=js"
export * from "./ShowCatastro.vue?vue&type=script&lang=js"

import "./ShowCatastro.vue?vue&type=style&index=0&id=19cacc37&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19cacc37"

export default script